import { render, staticRenderFns } from "./ChatReadingRecord.vue?vue&type=template&id=5a747554&scoped=true&"
import script from "./ChatReadingRecord.vue?vue&type=script&lang=js&"
export * from "./ChatReadingRecord.vue?vue&type=script&lang=js&"
import style0 from "./ChatReadingRecord.vue?vue&type=style&index=0&id=5a747554&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a747554",
  null
  
)

export default component.exports